import {
  ADD_TODO
} from "./actionType";

export default {
  updateEquipmentCode(state, data) {
    console.log(state)
  },
  shutMask(state, data) {
    this.state.mask = data
    console.log(data)
  },
  code(state, data) {
    this.state.code2 = data
  },
}